import { Typography, Stack, CurrencyTypography } from '@ace-clublabs/shared-component-library';

const FreePrice = () => {
  return (
    <Typography
      className="free-label"
      variant="b1Regular"
      sx={{
        alignSelf: 'center',
        color: '#3E6B20',
      }}
    >
      Free
    </Typography>
  );
};

export interface IPriceCartPricing {
  price?: string | number;
}

export const PriceCartPricing = ({ price }: IPriceCartPricing) => {
  const className = 'price-cart-pricing';

  if (price == undefined) {
    return <></>;
  }

  if (typeof price === 'string') {
    return (
      <Typography variant="b1Regular" className={className}>
        {price}
      </Typography>
    );
  }

  const noPrice = price === 0;

  if (noPrice) {
    return (
      <Stack className={className}>
        <FreePrice />
      </Stack>
    );
  }

  return <CurrencyTypography variant="b1Regular" className={className} value={price} />;
};
